import { ButtonProps, ThemeIcon, Button, Stack, Box, Text } from "@mantine/core";
import { IconBookmark, IconBriefcase, IconSparkles } from "@tabler/icons-react";
import Link from "next/link";
import { useRouter } from "next/router";

import { PaidFeatureModal, usePaidFeatureModalDisclosure } from "components/PaidFeatureModal";

const navLinkProps: ButtonProps = {
  fullWidth: true,
  variant: "subtle",
  size: "sm",
  justify: "flex-start",
  color: "gray",
  pl: 16, // Add proper left padding for better checkbox spacing
};

const iconMr = 2;
export const BenchmarkingToolsNavigation = ({ isGated = false }: { isGated: boolean }) => {
  const router = useRouter();
  const isOnSavedBenchmarks = router.asPath.includes("/saved-benchmarks");
  const isOnCustomJobs = router.asPath.includes("/internal-jobs");
  const isOnBenchmarkEmployees = router.asPath.includes("/benchmark-employees");
  const [paidFeatureModalState, paidFeatureModalHandlers] = usePaidFeatureModalDisclosure();

  const handleGatedClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    if (isGated) {
      e.preventDefault();
      paidFeatureModalHandlers.open("benchmarking-tools");
    }
  };

  return (
    <Box mt={16}>
      <Stack>
        <Text size="xs" c="dimmed" tt="uppercase" fw={600}>
          Tools
        </Text>
        <Button
          component={Link}
          href="/benchmarking/saved-benchmarks"
          bg={isOnSavedBenchmarks ? "gray.2" : undefined}
          onClick={handleGatedClick}
          leftSection={
            <ThemeIcon variant="transparent" color="gray" mr={iconMr}>
              <IconBookmark size={16} />
            </ThemeIcon>
          }
          {...navLinkProps}
        >
          Saved benchmarks
        </Button>
        <Button
          component={Link}
          href="/benchmarking/internal-jobs"
          bg={isOnCustomJobs ? "gray.2" : undefined}
          onClick={handleGatedClick}
          leftSection={
            <ThemeIcon variant="transparent" color="gray" mr={iconMr}>
              <IconBriefcase size={16} />
            </ThemeIcon>
          }
          {...navLinkProps}
        >
          Custom jobs
        </Button>
        <Button
          component={Link}
          href="/company/employees/benchmarks"
          bg={isOnBenchmarkEmployees ? "gray.2" : undefined}
          onClick={handleGatedClick}
          leftSection={
            <ThemeIcon variant="transparent" color="gray" mr={iconMr}>
              <IconSparkles size={16} />
            </ThemeIcon>
          }
          {...navLinkProps}
        >
          Benchmark employees
        </Button>
      </Stack>
      <PaidFeatureModal {...paidFeatureModalState} onClose={paidFeatureModalHandlers.close} />
    </Box>
  );
};
